import { render, staticRenderFns } from "./CreateBanPolicy.vue?vue&type=template&id=4da12356&"
import script from "./CreateBanPolicy.vue?vue&type=script&lang=ts&"
export * from "./CreateBanPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports